import { props } from '@ngrx/store';
import { createAsyncAction } from '../../async-state/utils/async-state-action.utils';
import { ApiResponse, UserListItem } from '../../../shared/models';
import { CreateAndAddToSubmissionRequest } from '../../../shared/models/developer-mode/create-and-add-submission-request.model';
import { CreateAndAddToSubmissionResponse } from '../../../shared/models/developer-mode/create-and-add-submission-response.model';
import { CreateWeightEntryRequest } from '../../../shared/models/developer-mode/create-weight-entry-request.model';
import { Mail } from '../../../shared/models/developer-mode/mail.model';
import { ConnectionTypes } from '../../../shared/models/developer-mode/connection-types.model';

export namespace DeveloperActions {
  export enum DeveloperApiActionTypes {
    CreateAndAddSubmission = '[Developer] Create and Add Submission',
    CreateAndAddSubmissionSuccess = '[Developer] Create and Add Submission Success',
    CreateAndAddSubmissionFail = '[Developer] Create and Add Submission Fail',

    CreateWeightEntry = '[Developer] Create Weight Entry',
    CreateWeightEntrySuccess = '[Developer] Create Weight Entry Success',
    CreateWeightEntryFail = '[Developer] Create Weight Entry Fail',

    TriggerUserMail = '[Developer] Trigger User Mail',
    TriggerUserMailSuccess = '[Developer] Trigger User Mail Success',
    TriggerUserMailFail = '[Developer] Trigger User Mail Fail',

    ConnectUsers = '[Developer] Connect Users',
    ConnectUsersSuccess = '[Developer] Connect Users Success',
    ConnectUsersFail = '[Developer] Connect Users Fail',

    RemoveUserConnection = '[Developer] Remove User Connection',
    RemoveUserConnectionSuccess = '[Developer] Remove User Connection Success',
    RemoveUserConnectionFail = '[Developer] Remove User Connection Fail',
  }

  export const createAndAddSubmission = createAsyncAction(
    DeveloperApiActionTypes.CreateAndAddSubmission,
    {
      asyncKey: DeveloperApiActionTypes.CreateAndAddSubmission,
      asyncState: 'start',
    },
    props<{ payload: CreateAndAddToSubmissionRequest }>()
  );

  export const createAndAddSubmissionSuccess = createAsyncAction(
    DeveloperApiActionTypes.CreateAndAddSubmissionSuccess,
    {
      asyncKey: DeveloperApiActionTypes.CreateAndAddSubmission,
      asyncState: 'success',
    },
    props<{ response: ApiResponse<CreateAndAddToSubmissionResponse> }>()
  );

  export const createAndAddSubmissionFail = createAsyncAction(
    DeveloperApiActionTypes.CreateAndAddSubmissionFail,
    {
      asyncKey: DeveloperApiActionTypes.CreateAndAddSubmission,
      asyncState: 'fail',
    },
    props<{ error: any }>()
  );

  export const createWeightEntry = createAsyncAction(
    DeveloperApiActionTypes.CreateWeightEntry,
    {
      asyncKey: DeveloperApiActionTypes.CreateWeightEntry,
      asyncState: 'start',
    },
    props<{ payload: CreateWeightEntryRequest }>()
  );

  export const createWeightEntrySuccess = createAsyncAction(
    DeveloperApiActionTypes.CreateWeightEntrySuccess,
    {
      asyncKey: DeveloperApiActionTypes.CreateWeightEntry,
      asyncState: 'success',
    }
  );

  export const createWeightEntryFail = createAsyncAction(
    DeveloperApiActionTypes.CreateWeightEntryFail,
    {
      asyncKey: DeveloperApiActionTypes.CreateWeightEntry,
      asyncState: 'fail',
    },
    props<{ error: any }>()
  );

  export const triggerUserMail = createAsyncAction(
    DeveloperApiActionTypes.TriggerUserMail,
    {
      asyncKey: DeveloperApiActionTypes.TriggerUserMail,
      asyncState: 'start',
    },
    props<{ userId: string; mailType: Mail; requestedByUserId: string }>()
  );

  export const triggerUserMailSuccess = createAsyncAction(
    DeveloperApiActionTypes.TriggerUserMailSuccess,
    {
      asyncKey: DeveloperApiActionTypes.TriggerUserMail,
      asyncState: 'success',
    }
  );

  export const triggerUserMailFail = createAsyncAction(
    DeveloperApiActionTypes.TriggerUserMailFail,
    {
      asyncKey: DeveloperApiActionTypes.TriggerUserMail,
      asyncState: 'fail',
    },
    props<{ error: any }>()
  );

  export const connectUsers = createAsyncAction(
    DeveloperApiActionTypes.ConnectUsers,
    {
      asyncKey: DeveloperApiActionTypes.ConnectUsers,
      asyncState: 'start',
    },
    props<{
      connectionType: ConnectionTypes;
      sourceUserId: string;
      targetEmail: string;
    }>()
  );

  export const connectUsersSuccess = createAsyncAction(
    DeveloperApiActionTypes.ConnectUsersSuccess,
    {
      asyncKey: DeveloperApiActionTypes.ConnectUsers,
      asyncState: 'success',
    },
    props<{ user: UserListItem; connectionType: ConnectionTypes }>()
  );

  export const connectUsersFail = createAsyncAction(
    DeveloperApiActionTypes.ConnectUsersFail,
    {
      asyncKey: DeveloperApiActionTypes.ConnectUsers,
      asyncState: 'fail',
    },
    props<{ error: any }>()
  );

  export const removeUserConnection = createAsyncAction(
    DeveloperApiActionTypes.RemoveUserConnection,
    {
      asyncKey: DeveloperApiActionTypes.RemoveUserConnection,
      asyncState: 'start',
    },
    props<{
      connectionType: ConnectionTypes;
      sourceUserId: string;
      targetUserId: string;
    }>()
  );

  export const removeUserConnectionSuccess = createAsyncAction(
    DeveloperApiActionTypes.RemoveUserConnectionSuccess,
    {
      asyncKey: DeveloperApiActionTypes.RemoveUserConnection,
      asyncState: 'success',
    },
    props<{
      removedUserId: string;
      connectionType: ConnectionTypes;
    }>()
  );

  export const removeUserConnectionFail = createAsyncAction(
    DeveloperApiActionTypes.RemoveUserConnectionFail,
    {
      asyncKey: DeveloperApiActionTypes.RemoveUserConnection,
      asyncState: 'fail',
    },
    props<{ error: any }>()
  );

}
